import { createContext } from 'react'

export interface AppsVersionContextValue {
  contactsTargetBuild: string
  contactCenterTargetBuild: string
}

export default createContext<AppsVersionContextValue>({ contactsTargetBuild: '', contactCenterTargetBuild: '' })
